import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const PopupCloseIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" className={props.className} onClick={props.onClick} width="35" height="35" viewBox="0 0 512 512">
		<g transform="translate(-2 -2)">
			<g transform="translate(2 2)">
				<path
					d="M367.1,0H145.152C58.368,0,0,60.928,0,151.552V360.7C0,451.072,58.368,512,145.152,512H367.1C453.888,512,512,451.072,512,360.7V151.552C512,60.928,453.888,0,367.1,0"
					fill="#fff"
					opacity="0.1"
				/>
				<path
					d="M167.744,136.044,122.2,90.527,167.718,45.01a22.4,22.4,0,0,0-31.667-31.693L90.508,58.834,44.966,13.266A22.41,22.41,0,0,0,13.273,44.959L58.841,90.527l-45.466,45.44A22.4,22.4,0,0,0,45.043,167.66l45.466-45.466,45.568,45.542a22.4,22.4,0,1,0,31.667-31.693"
					transform="translate(165.458 165.281)"
					fill="#f5f5f5"
				/>
			</g>
		</g>
	</svg>
);
